import { ArticleParagraph1, ArticleParagraph2, ArticleParagraph3 } from '@cian/ui-kit';
import { BankList } from '../BankList';
import { AvailableNewbuildingList } from '../AvailableNewbuildingList';
import * as styles from './styles.css';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';

interface IPromoPopupDescriptionProps {
  promo: IPromoInfo;
  onCollapseClick(): void;
  isCollapsed: boolean;
  onMortgageClick(): void;
}

export function PromoPopupDescription({
  promo,
  isCollapsed,
  onCollapseClick,
  onMortgageClick,
}: IPromoPopupDescriptionProps) {
  const { availableJks, description, authorLogoUrl, authorName, bank, banks, features } = promo;

  return (
    <div className={styles['container']} data-testid="PromoPopup">
      {features && features.length > 0 && (
        <div className={styles['features']}>
          {features.map(feature => (
            <div className={styles['feature']} key={feature.name}>
              <ArticleParagraph3 color={'gray60_100'}>{feature.name}</ArticleParagraph3>
              <ArticleParagraph2 as={'p'} color={'text-primary-default'}>
                {feature.value}
              </ArticleParagraph2>
            </div>
          ))}
        </div>
      )}
      {description && (
        <div className={styles['description']}>
          <ArticleParagraph1 color="text-primary-default" whiteSpace="pre-line">
            {description}
          </ArticleParagraph1>
        </div>
      )}
      {availableJks && (
        <div className={styles['newbuilding-list']}>
          <AvailableNewbuildingList
            isCollapsed={isCollapsed}
            availableNewbuildingList={availableJks}
            onToggleClick={onCollapseClick}
          />
        </div>
      )}
      {bank && (
        <div className={styles['bank-list']}>
          <BankList banks={[bank]} onClick={onMortgageClick} />
        </div>
      )}
      {Array.isArray(banks) && !!banks.length && (
        <div className={styles['bank-list']}>
          <BankList banks={banks} onClick={onMortgageClick} />
        </div>
      )}
      {authorName && authorLogoUrl && (
        <div style={{ backgroundImage: `url(${authorLogoUrl})` }} className={styles['author']}>
          <div className={styles['author-content']}>
            <ArticleParagraph1 color="text-primary-default">{authorName}</ArticleParagraph1>
          </div>
        </div>
      )}
    </div>
  );
}
